import { clsx } from 'clsx';

import { Input } from '@monoimin/molecules/inputs/RealEstateInput';

import type { RangeProps } from '@monoimin/real-estate';

type RangeInputProps = Pick<
  RangeProps,
  'min' | 'max' | 'value' | 'onChange' | 'onKeyDown'
> & { className?: string; fromPlaceholder?: string; toPlaceholder?: string };

export const RangeInput = ({
  min,
  max,
  value = [],
  onChange,
  onKeyDown,
  className,
  fromPlaceholder,
  toPlaceholder,
}: RangeInputProps) => {
  return (
    <div className={clsx('grid grid-cols-15 gap-2', className)}>
      <Input
        min={min}
        max={max}
        className='col-span-7 relative'
        value={value[0]}
        onChange={(event) => {
          if (typeof onChange === 'function') {
            onChange([event.target.value, value[1]]);
          }
        }}
        onKeyDown={onKeyDown}
        type='number'
        placeholder={fromPlaceholder}
        size='large'
      />
      <div className='flex items-center justify-center'>
        <div className='w-4 h-px bg-black-500'></div>
      </div>
      <Input
        min={min}
        max={max}
        className='col-span-7 relative'
        value={value[1]}
        onChange={(event) => {
          if (typeof onChange === 'function') {
            onChange([value[0], event.target.value]);
          }
        }}
        onKeyDown={onKeyDown}
        type='number'
        placeholder={toPlaceholder}
        size='large'
      />
    </div>
  );
};
